import angular from 'angular';

import InventoryOrderHistoryChainTabComponent from './inventory-order-history-chain-tab-component';

export default angular
  .module('inventory-order-history-chain-tab', [])
  .component('inventoryOrderHistoryChainTab', new InventoryOrderHistoryChainTabComponent());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-order-history-chain-tab/inventory-order-history-chain-tab-module.js